import React, { useEffect, useState } from 'react'
import AdminSidebar from './AdminSidebar'
import AdminHeader from './AdminHeader'
import axios from 'axios';
import { base_url } from './AdminUsers';
import api from '../../../utils/api';

const AdminBankList = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [momo, setMomo]= useState();

    const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  const fetchBankDetails = async () => {

      try {
        const auth=localStorage.getItem('admin');
        const res = await api.post("/admin/manager/settings/get", {
          auth,
          headers: {
            Accept: "application/json",
          },
        });
        console.log(res?.data.momo);
        if(res.data.status){
            setMomo(res?.data.momo);
        }
        
      } catch (error) {
        console.error(error);
      }
    };

  useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
        
        // On desktop, sidebar should always be "open"
        if (!mobile) {
          setIsSidebarOpen(true);
        }
      };
      
      window.addEventListener('resize', handleResize);
      fetchBankDetails();
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    
    return (
        <div className="wrapper">
        {/* Main Sidebar */}
    
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >

            <h3>UPI Id's</h3>

                <div>
                    <div className="col-md-3">
                    <div className="card mini-stats-wid rounded shadow">
                        <div className="card-body">
                            {/* <div className="rounded">
                                <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                            </div> */}
                            <div>
                                <p className="text-muted fw-bold">UPI 1</p>
                                <p className="border p-2 rounded shadow w-100">{momo?.upi_id}</p>
                            </div>

                        </div>
                    </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card mini-stats-wid rounded shadow">
                            <div className="card-body">
                                {/* <div className="rounded">
                                    <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                                </div> */}
                                <div>
                                    <p className="text-muted fw-bold">UPI 2</p>
                                    <p className="border p-2 rounded shadow w-100">{momo?.upi_id2}</p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card mini-stats-wid rounded shadow">
                            <div className="card-body">
                                {/* <div className="rounded">
                                    <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                                </div> */}
                                <div>
                                    <p className="text-muted fw-bold">UPI 3</p>
                                    <p className="border p-2 rounded shadow w-100">{momo?.upi_id3}</p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card mini-stats-wid rounded shadow">
                            <div className="card-body">
                                {/* <div className="rounded">
                                    <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                                </div> */}
                                <div>
                                    <p className="text-muted fw-bold">UPI 4</p>
                                    <p className="border p-2 rounded shadow w-100">{momo?.upi_id4}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            <h3>Bank Details</h3>

            <div className=''>

                <div className="col-md-3 w-100">
                    <div className="card mini-stats-wid rounded shadow">
                        <div className="card-body d-flex flex-column">
                            {/* <div className="rounded">
                                <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                            </div> */}
                            <div>
                                <p className="text-muted fw-bold">Holder Name</p>
                                <p className="border p-2 rounded shadow w-100">{momo?.holder_name}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Bank Name</p>
                                <p className="border p-2 rounded shadow">{momo?.bank_name}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Account Number</p>
                                <p className="border p-2 rounded shadow">{momo?.account_number}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">IFSC Code</p>
                                <p className="border p-2 rounded shadow">{momo?.ifsc_code}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card mini-stats-wid rounded shadow">
                        <div className="card-body d-flex flex-column">
                            {/* <div className="rounded">
                                <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                            </div> */}
                            <div>
                                <p className="text-muted fw-bold">Holder Name</p>
                                <p className="border p-2 rounded shadow w-100">{momo?.holder_name2}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Bank Name</p>
                                <p className="border p-2 rounded shadow">{momo?.bank_name2}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Account Number</p>
                                <p className="border p-2 rounded shadow">{momo?.account_number2}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">IFSC Code</p>
                                <p className="border p-2 rounded shadow">{momo?.ifsc_code2}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card mini-stats-wid rounded shadow">
                        <div className="card-body d-flex flex-column">
                            {/* <div className="rounded">
                                <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                            </div> */}
                            <div>
                                <p className="text-muted fw-bold">Holder Name</p>
                                <p className="border p-2 rounded shadow w-100">{momo?.holder_name3}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Bank Name</p>
                                <p className="border p-2 rounded shadow">{momo?.bank_name3}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Account Number</p>
                                <p className="border p-2 rounded shadow">{momo?.account_number3}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">IFSC Code</p>
                                <p className="border p-2 rounded shadow">{momo?.ifsc_code3}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" col-md-3">
                    <div className="card mini-stats-wid rounded shadow">
                        <div className="card-body d-flex flex-column">
                            {/* <div className="rounded">
                                <i className="fa fa-user-plus fs-1 px-2 pt-3" ></i>
                            </div> */}
                            <div>
                                <p className="text-muted fw-bold">Holder Name</p>
                                <p className="border p-2 rounded shadow w-100">{momo?.holder_name4}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Bank Name</p>
                                <p className="border p-2 rounded shadow">{momo?.bank_name4}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">Account Number</p>
                                <p className="border p-2 rounded shadow">{momo?.account_number4}</p>
                            </div>

                            <div>
                                <p className="text-muted fw-bold">IFSC Code</p>
                                <p className="border p-2 rounded shadow">{momo?.ifsc_code4}</p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
  
            
        </div>
    </div>
    )
}

export default AdminBankList